export const PRESET_SIZES = {
	lg: { w: 300, h: 140 },
} as const;

export const EXTENSION = 'png';

export const CONTENTS = [
	'amur_white',
	'amur_black',
	'buffalo_bigmouth',
	'carp_mirror',
	'smelt',
	'rudd',
	'kutum',
	'bream',
	'salmon_atlantic',
	'perch',
	'sturgeon_persian',
	'shad_caspian',
	'catfish',
	'sturgeon_sterlet',
	'pikeperch',
	'roach',
	'silver_carp_bighead',
	'eel',
	'trout_lake',
	'sabrefish',
	'pike_common',
	'crab',
	'crab_king',
	'crayfish',
	'lobster',
	'lobster_blue',
	'lobster_spiny',
] as const;
